import React, { useRef } from 'react';
import { Typography } from './Typography';
import { useTruncateText } from '../../helpers/hooks/useTruncateText';
import Tooltip from '@material-ui/core/Tooltip';

/**
 *Changes the color of the text depending on whether its highlighted or not
 */
export interface HighlightProps {
  text?: string;
  /**When highlight exists the text will have different color */
  highlight?: string;
  /** */
  toolTip?: boolean;
  /**Placement of the tooltip */
  tooltipPlacement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start';
  suffix?: string;
}

export const Highlight = (props: HighlightProps) => {
  const {
    text,
    highlight = '',
    toolTip = true,
    tooltipPlacement,
    suffix
  } = props;

  const suffixRef = useRef();

  const { containerRef, stringsArray } = useTruncateText({
    str: text,
    lines: 1,
    highlightedText: highlight,
    suffixComponentRef: suffixRef
  });

  //for cases when the searchItem is displayed  but search input is empty
  if (!highlight) {
    return (
      <div ref={containerRef}>
        <Typography variant="sm" colorVariant="03">
          {stringsArray[0]}
        </Typography>
      </div>
    );
  }

  const highlightExp = new RegExp(`(${highlight})`, 'i');

  const parts = stringsArray[0]?.split(highlightExp);

  //Tooltip
  const arrayToString = (arr: string[]) =>
    arr.reduce((acc, str) => acc + str, '');

  return (
    <div style={{ display: 'flex', position: 'relative' }}>
      <Typography
        ref={containerRef}
        style={{
          display: 'block',
          textWrap: 'nowrap',
          flexGrow: 1,
          flexShrink: 1,
          maxWidth: '100%'
        }}
        variant="sm"
        colorVariant="01"
      >
        <Tooltip
          title={text ? text : ''}
          placement={tooltipPlacement}
          disableFocusListener={true}
          disableTouchListener={true}
          disableHoverListener={
            !toolTip || arrayToString(stringsArray) === text
          }
        >
          <span>
            {parts?.map((part, index) =>
              highlightExp.test(part) ? (
                <Typography key={index} variant="sm" colorVariant="01">
                  {part}
                </Typography>
              ) : (
                <Typography
                  variant="sm"
                  colorVariant="03"
                  key={index + '__highlight'}
                >
                  {part}
                </Typography>
              )
            )}
            <span
              ref={suffixRef}
              style={{
                display: 'inline-block',
                whiteSpaceCollapse: 'preserve'
              }}
            >
              <Typography variant="sm" colorVariant="03">
                {suffix}
              </Typography>
            </span>
          </span>
        </Tooltip>
      </Typography>
    </div>
  );
};
